import { Tab } from '@headlessui/react';
import classNames from 'classnames';

export const StyledTab = ({ children }) => {
  return (
    <Tab
      className={({ selected }) =>
        classNames('m-0 focus:outline-none ', {
          'border-b-2 border-ds-primary': selected,
        })
      }
    >
      {({ selected }) => (
        <div
          className={classNames(
            'flex hover:bg-ds-natural-50 rounded-md px-4 py-4',
            selected
              ? 'text-ds-primary-300 hover:text-ds-primary-300'
              : 'text-ds-natural-300 hover:text-ds-natural-500'
          )}
        >
          {children}
        </div>
      )}
    </Tab>
  );
};
